import { render, staticRenderFns } from "./create-tag.vue?vue&type=template&id=2f465c9a&scoped=true"
import script from "./create-tag.vue?vue&type=script&lang=js"
export * from "./create-tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f465c9a",
  null
  
)

export default component.exports